// LIST
export const FETCH_HOMES = "app/Homes/FETCH_HOMES";
export const FETCH_HOMES_SUCCESS = "app/Homes/FETCH_HOMES_SUCCESS";
export const FETCH_HOMES_FAILURE = "app/Homes/FETCH_HOMES_FAILURE";

// GET VIEW DATA
export const GET_VIEW_DATA = "app/Homes/GET_VIEW_DATA";
export const GET_VIEW_DATA_SUCCESS = "app/Homes/GET_VIEW_DATA_SUCCESS";
export const GET_VIEW_DATA_FAILURE = "app/Homes/GET_VIEW_DATA_FAILURE";
// ADD
export const ADD_HOME = "app/Homes/ADD_HOME";
export const ADD_HOME_SUCCESS = "app/Homes/ADD_HOME_SUCCESS";
export const ADD_HOME_FAILURE = "app/Homes/ADD_HOME_FAILURE";
// EDIT
export const EDIT_HOME = "app/Homes/EDIT_HOME";
export const EDIT_HOME_SUCCESS = "app/Homes/EDIT_HOME_SUCCESS";
export const EDIT_HOME_FAILURE = "app/Homes/EDIT_HOME_FAILURE";
// DELETE
export const DELETE_HOME = "app/Homes/DELETE_HOME";
export const DELETE_HOME_SUCCESS = "app/Homes/DELETE_HOME_SUCCESS";
export const DELETE_HOME_FAILURE = "app/Homes/DELETE_HOME_FAILURE";
// SEARCH
export const SEARCH_HOME = "app/Homes/SEARCH_HOME";
export const SEARCH_HOME_SUCCESS = "app/Homes/SEARCH_HOME_SUCCESS";
export const SEARCH_HOME_FAILURE = "app/Homes/SEARCH_HOME_FAILURE";
